function e(e){if(typeof e!=`object`||!e)return!1;let t=Object.getPrototypeOf(e);return t===null||t===Object.prototype}export{e as isPlainObject};
//# sourceMappingURL=isPlainObject-Crc4dM9-.js.map